var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"11","md":"10"}},[_c('patientForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }